/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createApiAction } from 'api/core';


export const createPushToCardUrl = createApiAction({
  method: 'post',
  url: '/api/pushToCard/url',
  requestBodyMapper: r => r,
  responseMapper: r => r
});

export const refreshPushToCardAccounts = createApiAction({
  method: 'post',
  url: '/api/pushToCard/refresh',
  requestBodyMapper: r => r,
  responseMapper: r => r
});

export const getPushToCards = createApiAction({
  method: 'get',
  url: '/api/pushToCard/list',
  queryStringMapper: r => r,
  responseMapper: r => r
});

export const updatePushToCard = createApiAction({
  method: 'put',
  url: '/api/pushToCard/:id',
  requestBodyMapper: r => r,
  responseMapper: r => r
});